import { useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { hasSectionAction } from '../utils/permissions';

export function useSectionAccess(pathname) {
  const { user } = useAuth();
  const location = useLocation();
  const path = pathname || location.pathname || '';
  return {
    path,
    canView: hasSectionAction(user, path, 'read'),
    canCreate: hasSectionAction(user, path, 'create'),
    canUpdate: hasSectionAction(user, path, 'update'),
    canDelete: hasSectionAction(user, path, 'delete'),
  };
}

export default useSectionAccess;
